var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: `editApiKeyCommentModal-${_vm.keyId}`,
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.edit_api_key_comment"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateComment()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-input-group-form-input", {
        attrs: {
          id: "name-input",
          "input-group-size": "mb-3",
          type: "text",
          lazy: "true",
          feedback: "true",
          autofocus: "false",
          label: _vm.$t("admin.api_key_comment"),
        },
        model: {
          value: _vm.comment,
          callback: function ($$v) {
            _vm.comment = $$v
          },
          expression: "comment",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }